import { find } from 'lodash'

import { setPage } from 'store/actions/tables'
import { updateLocalSetting } from 'store/actions/settings'
import { store } from 'store/reducers'
import { OptionsToSaveType } from 'components/UI/Filter/hooks/useUpdateSettings'
import { MFilters } from 'types/filterTypes'

type saveOptionsType = (
  optionsToSave: OptionsToSaveType,
  {
    ignoreLargeCompany
  }?: {
    ignoreLargeCompany?: boolean | undefined
  }
) => void

const onClickPunchCardOverlappingTimeOffAlert = (saveOptions: saveOptionsType, savedOptions: MFilters.FilterTypes['filter-punchCards']) => {
  // If the isonTimeoff flag option is already chosen, do nothing
  if (savedOptions?.flags && find(savedOptions?.flags, option => option === 'isOnTimeoff')) return
  // Add isOnTimeoff flag  filter to savedOptions
  const options = { ...savedOptions, flags: [...(savedOptions?.flags || []), 'isOnTimeoff'] }
  saveOptions(options, { ignoreLargeCompany: true })
  store.dispatch(updateLocalSetting(`last-page-viewed-punchCards`, 1))
  store.dispatch(setPage('punchCards', 1))
}

export default onClickPunchCardOverlappingTimeOffAlert
